import { XMLToJSON } from 'helpers/xmlToJson';


interface Cell {
    _: string;
}

interface Column {
    _: string;
    $: any;
}

interface Row {
    cell: Cell[];
}

interface Head {
    column: Column[];
}

interface DataConverted {
    rows: {
        head: Head[];
        row: Row[];
    };
}

export const getDataSorts = async (data: string) => {
    try {
        const dataConverted: DataConverted = await XMLToJSON(data);
        const dataSorts = dataConverted.rows.head[0]?.column
        //.filter((item) => item.$.width !== "0") 
        .map((item) => {
            return item.$.sort; 
        });
        return dataSorts;

    } catch (error) {
        //console.error('Error processing data:', error);
    }
} 

